import {Component} from 'react';
import Redirections from "../../lib/Redirections";

class BeforeResults extends Component {
	constructor(props) {
		super(props);
		let keysToRemove = [
			"filterFrame",
			"filterBrake",
			"filterChainRings",
			"cassette",
			"max_weight",
			"sorting",
			"driveChainWeight",
			"suspensionWeight",
			"wheelsWeight",
			"brakesWeight",
			"guaranteeWeight",
			"weightWeight",
			'noResults'
		];

		keysToRemove.forEach(key =>
			localStorage.removeItem(`${props.traject}_${key}`))

		this.props.goTo('/advice/result', this.props.traject);
		if (this.props.traject === 'race') {
			Redirections.replaceTo('/road/advice/result');
		} else {
			Redirections.replaceTo('/mtb/advice/result');
		}
	}
}
export default BeforeResults;
